let municipiosCache = null;

const IBGE_MUNICIPIOS_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades/municipios';
const MUNICIPIOS_CACHE_KEY = 'municipios_br_cache_v1';

function readLocalCache() {
  try {
    const raw = localStorage.getItem(MUNICIPIOS_CACHE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
}

function writeLocalCache(municipios) {
  try {
    localStorage.setItem(MUNICIPIOS_CACHE_KEY, JSON.stringify(municipios));
  } catch (error) {
    // Sem acao: cache local e opcional.
  }
}

export async function listarMunicipiosBrasil() {
  if (Array.isArray(municipiosCache) && municipiosCache.length > 0) {
    return municipiosCache;
  }

  const localCache = readLocalCache();
  if (Array.isArray(localCache) && localCache.length > 0) {
    municipiosCache = localCache;
    return municipiosCache;
  }

  const response = await fetch(IBGE_MUNICIPIOS_URL);
  if (!response.ok) {
    throw new Error('Nao foi possivel carregar municipios do IBGE');
  }

  const data = await response.json();
  municipiosCache = Array.isArray(data)
    ? data.map((municipio) => {
        const nome = municipio?.nome || '';
        const uf = municipio?.microrregiao?.mesorregiao?.UF?.sigla || '';
        const label = uf ? `${nome} - ${uf}` : nome;

        return {
          id: municipio?.id,
          nome,
          uf,
          label,
        };
      })
        .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
    : [];

  if (municipiosCache.length > 0) {
    writeLocalCache(municipiosCache);
  }

  return municipiosCache;
}
